// extracted by mini-css-extract-plugin
export var buttonContainer = "PrimaryLink-module__buttonContainer___qyjK8";
export var desktopButton = "PrimaryLink-module__desktopButton___tYzRv";
export var mobileButton = "PrimaryLink-module__mobileButton___r_4wL";